import { Enumify } from "enumify-ts";
import { InsuranceCategoryEnum } from "../routes/tenants/api/Representation";
class InsuranceCategory extends Enumify() {
    description;
    static MOTOR_VEHICLE = new InsuranceCategory('Motor Vehicle');
    static PUBLIC_LIABILITY = new InsuranceCategory('Public Liability');
    static WORK_COVER = new InsuranceCategory('Workcover');
    static IN_TRANSIT = new InsuranceCategory('In Transit');
    static _ = InsuranceCategory._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return InsuranceCategory.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
    static description(insuranceCategory) {
        if (insuranceCategory) {
            const eobj = InsuranceCategory.valueOf(insuranceCategory);
            if (eobj) {
                return eobj.description;
            }
            return insuranceCategory;
        }
        return "";
    }
}
export default InsuranceCategory;
